import styled from 'styled-components';

import fundo from '~/Images/fundo-onda-revo.svg';

import { AvatarImage } from '~/Styles';

export const FiltrosRanking = styled.ul`
  margin: 10px 0 0;
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center !important;
  text-align: center;
  gap: 10px;

  .dropdown-toggle {
    min-width: 120px;
  }

  @media (min-width: 768px) {
    flex-direction: row !important;
    align-items: flex-end !important;
  }

  @media (min-width: 992px) {
    z-index: 15;
    position: absolute;
    right: 50px;
    text-align: right;
    flex-direction: column !important;
    align-items: flex-end !important;
  }
`;

export const Recebiveis = styled.ul`
  display: flex;
  list-style-type: none;
  align-items: flex-start !important;
  justify-content: left;
  text-align: left;
  color: #fff;
  margin: 10px 0;
  line-height: 1;

  li {
    margin: 0 10px;
  }

  @media (min-width: 992px) {
    z-index: 16;
    flex-direction: column !important;
    position: absolute;

    li {
      margin: 0 0 10px;
    }
    strong {
      font-size: 1.6em;
      small {
        font-size: 12px;
      }
    }
  }
`;

export const FiltroData = styled.ul`
  display: flex;
  list-style-type: none;
  align-items: flex-start !important;
  justify-content: left;
  text-align: left;
  color: #fff;
  margin: 10px 0;
  line-height: 1;

  @media (min-width: 992px) {
    z-index: 16;
    flex-direction: column !important;
    position: absolute;
    left: 50px;
  }
`;

export const ControlesRanking = styled.div`
  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    width: min(100%, 340px);
    margin: 10px auto 0;

    ${FiltrosRanking} {
      display: contents;
      margin: 0;

      li {
        width: 100%;
      }

      .dropdown,
      .dropdown-toggle {
        width: 100%;
      }
    }

    ${FiltroData} {
      grid-column: 2;
      width: 100%;
      margin: 0;

      button {
        width: 100%;
      }
    }
  }
`;

export const ContainerCorretores = styled.div`
  background: url(${fundo}) no-repeat top center;
  background-size: auto 450px;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 40px;

  @media (max-width: 767px) {
    background-size: auto 540px;
  }

  @media (min-width: 1366px) {
    background-size: auto 410px;
  }

  ${AvatarImage} {
    border-radius: 50%;
    border: 1px solid #eee;
  }

  .Loading {
    color: #fff;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: auto;
    justify-content: center;
    max-width: 400px;
  }

  header {
    color: #fff;
    margin-top: 20px;
    margin-bottom: 10px;

    @media (min-width: 1200px) {
      margin-bottom: 20px;
    }

    h4 {
      margin-bottom: 0;
      font-weight: 400;
      @media (min-width: 1200px) {
        font-size: 30px;
      }
    }
    h2 {
      color: #fac83d;
      font-weight: 700;
      @media (min-width: 1200px) {
        font-size: 34px;
      }
    }

    ul {
      margin-top: 10px;
      align-items: flex-start;
      max-width: 600px;
    }
  }
`;
